<template>
  <div class="row site-contents">
    <div class="col-sm-8 form-wrapper">
      <div class="payment-form" v-bind:class="{purchasePacks:routePath == '/purchasePacks' }">
        <img
          v-if="routePath != '/purchasePacks'"
          class="close"
          src="assets/images/close.svg"
          data-dismiss="modal"
          aria-label="Close"
          @click="closePaymentModal()"
        />
        <h3>Purchase Packs</h3>
        <!-- default purchase screen -->
        <!-- <template v-if="paymentInitiated == false"> -->
        <div class="event-count">
          <p>
            Available Free Events:
            <strong>
              <template v-if="userDetails.remainingEventsCount.isOnTrial">Unlimited</template>
              <template v-else>{{ userDetails.remainingEventsCount.freeEventsRemaining}}</template>
            </strong>
          </p>
          <p>
            Available Paid Events:
            <strong>{{ userDetails.remainingEventsCount.purchasedEventsRemaining}}</strong>
          </p>
        </div>
        <!-- alerts -->
        <div class="alert-section">
          <div
            class="alert alert-success alert-dismissible"
            :show="dismissCountDown"
            dismissible
            variant="success"
            @dismissed="dismissCountDown=0"
            @dismiss-count-down="countDownChanged"
            v-if="apiSuccessMessage!=null"
          >
            {{apiSuccessMessage}}
            <img
              class="close"
              src="assets/images/close.svg"
              data-dismiss="alert"
              aria-label="close"
              @click="showSuccessAlertMessage=!showSuccessAlertMessage"
            />
          </div>
          <div
            class="alert alert-danger alert-dismissible"
            :show="dismissCountDown"
            dismissible
            variant="danger"
            @dismissed="dismissCountDown=0"
            @dismiss-count-down="countDownChanged"
            v-if="apiErrorMessage!=null"
          >
            {{ apiErrorMessage }}
            <img
              class="close"
              src="assets/images/close.svg"
              data-dismiss="alert"
              aria-label="close"
              @click="showSuccessAlertMessage=!showSuccessAlertMessage"
            />
          </div>

          <!-- change default payment method -->
          <router-link
            class="align-right change-payment-method"
            to="/accountDetails?page=payment-option"
            target="_blank"
          >{{ changeCardText }}</router-link>
        </div>
        <div class="purchase-option">
          <div class="event-count" v-if="userDetails.remainingEventsCount.isOnTrial">
            <p>
              All Events are free until
              <strong>{{ userDetails.trialPeriodEndAt | moment("Do MMM YYYY")}}</strong>
            </p>
          </div>

          <ul
            class="purchase-list"
            v-bind:class="{ 'disabled': userDetails.remainingEventsCount.isOnTrial }"
          >
            <li
              v-bind:key="index"
              v-for="(pricing,index)
                       in eventPricing"
              class="list-item"
            >
              <div class="price-scheme">
                {{pricing.quantity==1?'Single Event':'Five Events'}} ${{pricing.price}}
                <p class="purchase-info">{{pricing.quantity==1?'Make one event':'Make five events'}}</p>
              </div>

              <button
                class="btn btn-primary"
                v-bind:class="{disabled:pricing.quantity==1?buttonDisabled1:buttonDisabled5}"
                @click="purchaseEvent(pricing.quantity)"
              >{{pricing.quantity==1?buttonText1:buttonText5}}</button>
            </li>
          </ul>
        </div>
        <!-- </template>
        <!-- stripe payment elements 
        <template v-else>
          <stripe-elements :selectedQuantity="selectedQuantity"></stripe-elements>
        </template>-->
      </div>
    </div>
  </div>
</template>

<script>
import { vuex, mapState } from "vuex";
import Vue from "vue";
import {
  CONFIRM_PAYMENT,
  UPDATE_PAYMENT_DETAIL
} from "../../store/payment/action.type";
//import mutations
import { SET_REMAINING_EVENTS_COUNT_MUTATION } from "../../store/auth/mutation.type";
import { SET_EVENT_PRICING_MUTATION } from "../../store/wishlist/mutation.type";
import {
  GET_REMAINING_EVENTS_COUNT,
  GET_EVENT_PRICING
} from "../../store/wishlist/action.type";

const PUB_KEY = process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY;

const stripe = Stripe(PUB_KEY);

export default {
  name: "purchaseEvents",
  props: [],
  data() {
    return {
      // showSpinner: false,
      apiSuccessMessage: null,
      apiErrorMessage: null,
      dismissSecs: 5,
      dismissCountDown: 0,
      addText: "Add",
      disableButton: false,
      paymentInitiated: false,
      buttonText1: "Buy Now",
      buttonText5: "Buy Now",
      buttonDisabled1: false,
      buttonDisabled5: false,
      routePath: null,
      changeCardText: "Change default payment method?",
      showSuccessAlertMessage: false
    };
  },

  computed: {
    ...mapState({
      userDetails: state => state.auth.userDetails,
      eventPricing: state => state.wishlist.eventPricing
    })
  },
  mounted() {
    this.routePath = this.$route.path;
    this.updateRemainingEventCount();
  },
  methods: {
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs;
    },
    //on purchase event
    purchaseEvent(quantity) {
      let self = this;
      this.apiSuccessMessage = null;
      this.apiErrorMessage = null;

      if (quantity == 1) {
        self.buttonText1 = "Please wait...";
        self.buttonDisabled1 = true;
      } else {
        self.buttonText5 = "Please wait...";
        self.buttonDisabled5 = true;
      }
      let params = {
        purchaseQuantity: quantity
      };
      //confirm payment
      self.$store
        .dispatch(CONFIRM_PAYMENT, params)
        .then(response => {
          this.apiSuccessMessage = null;
          this.apiErrorMessag = null;
          // console.log(response);
          if (response.status == 200) {
            let clientSecret = response.data.data.clientSecret;

            //client side confirm payment
            stripe.confirmCardPayment(clientSecret).then(function(result) {
              if (result.paymentIntent.status == "succeeded") {
                self.updatePurchaseDetail(quantity, result.paymentIntent);
                self.changeCardText = "Change default payment method?";
              } else {
                if (response.data.data.cardCount == 0) {
                  self.changeCardText = "Add New Card";
                } else {
                  self.changeCardText = "Change default payment method?";
                }
                self.showAlertMessage = true;
                self.apiErrorMessage =
                  "Error processing payment. Please try again.";
                self.apiSuccessMessage = null;
                if (quantity == 1) {
                  self.buttonText1 = "Buy Now";
                  self.buttonDisabled1 = false;
                } else {
                  self.buttonText5 = "Buy Now";
                  self.buttonDisabled5 = false;
                }
              }
            });
          } else {
            self.showAlertMessage = true;
            self.apiErrorMessage = response.data.message;

            if (response.data.data.cardCount == 0) {
              self.changeCardText = "Add New Card";
            } else {
              self.changeCardText = "Change default payment method?";
            }
            self.apiSuccessMessage = null;
            if (quantity == 1) {
              self.buttonText1 = "Buy Now";
              self.buttonDisabled1 = false;
            } else {
              self.buttonText5 = "Buy Now";
              self.buttonDisabled5 = false;
            }
          }

          self.showAlert();
        })
        .catch(error => {
          self.changeCardText = "Add New Card";

          if (quantity == 1) {
            self.buttonText1 = "Buy Now";
            self.buttonDisabled1 = false;
          } else {
            self.buttonText5 = "Buy Now";
            self.buttonDisabled5 = false;
          }
          self.showAlertMessage = true;
          self.apiErrorMessage = error.response.data.message;
          self.apiSuccessMessage = null;
          self.showAlert();
        });
    },
    //update db records after purchase
    updatePurchaseDetail(quantity, result) {
      console.log(result);
      let self = this;
      let params = {
        quantity: quantity,
        amount: result.amount,
        purchasedAt: result.created * 1000 //seconds to milliseconds
      };
      //confirm payment
      self.$store
        .dispatch(UPDATE_PAYMENT_DETAIL, params)
        .then(response => {
          self.apiSuccessMessage = null;
          self.apiErrorMessag = null;
          // console.log(response);
          if (response.status == 200) {
            self.showAlertMessage = true;
            self.apiSuccessMessage = response.data.message;
            self.apiErrorMessage = null;

            //get remaining events and update store
            self.updateRemainingEventCount();

            if (quantity == 1) {
              self.buttonText1 = "Buy Now";
              self.buttonDisabled1 = false;
            } else {
              self.buttonText5 = "Buy Now";
              self.buttonDisabled5 = false;
            }
          } else {
            self.showAlertMessage = true;
            self.apiErrorMessage = response.data.message;
            self.apiSuccessMessage = "";
          }

          self.showAlert();
        })
        .catch(error => {
          if (quantity == 1) {
            self.buttonText1 = "Buy Now";
            self.buttonDisabled1 = false;
          } else {
            self.buttonText5 = "Buy Now";
            self.buttonDisabled5 = false;
          }
          self.showAlertMessage = true;
          self.apiErrorMessage = error.response.data.message;
          self.apiSuccessMessage = null;
          self.showAlert();
        });
    },
    closePaymentModal() {
      let params = {
        page: this.page,
        perPageLimit: this.perPageLimit
      };
      //get remaining events
      this.$store
        .dispatch(GET_REMAINING_EVENTS_COUNT, params)
        .then(response => {
          // console.log(response);
          //update state to display counts in navigation bar
          this.$store.commit(SET_REMAINING_EVENTS_COUNT_MUTATION, response);
        })
        .catch(error => {
          console.log(error);
        });
    },
    updateRemainingEventCount() {
      let params = {
        page: this.page,
        perPageLimit: this.perPageLimit
      };

      //get remaining events and update store
      this.$store
        .dispatch(GET_REMAINING_EVENTS_COUNT, params)
        .then(response => {
          // console.log(response);
          //update state to display counts in navigation bar
          this.$store.commit(SET_REMAINING_EVENTS_COUNT_MUTATION, response);
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>
<style>
.price-scheme {
  float: left;
  width: 70%;
  font-size: 1.2rem;
  font-weight: 500;
}
.purchase-list {
  margin-top: 20px;
}
.form-wrapper {
  margin: 0px auto;
}
.list-item {
  padding: 20px;
  background: #f9f3ff;
  box-shadow: 0 10px 30px 0 rgba(121, 92, 153, 0.38);
  margin-top: 20px;
  border-radius: 0.75rem 0.75rem 0.75rem 0.75rem;
}
.payment-form {
  background: #fff;
  border-radius: 0.75rem 0.75rem 0.75rem 0.75rem;

  margin-bottom: 1.5625rem;
  padding: 1.875rem 1.875rem 2.8125rem 1.875rem;
}
.payment-form h3 {
  color: #3f3d55;

  font-family: "Rubik", sans-serif;

  font-weight: 500;

  margin-bottom: 2rem;
}
.purchasePacks {
  margin-top: 20px;
}
.purchase-info {
  color: rgba(109, 91, 151, 0.5);
  padding-top: 5px;
  font-weight: 400;
}
.disabled {
  opacity: 0.75;
  pointer-events: none;
}
.change-payment-method {
  color: #fd3e75;
}
.alert {
  margin-top: 20px;
}
</style>